import {
  dataLayerSnippet,
  GTMSnippetByEnvironment,
  GTMIframeSnippetByEnvironment,
} from './snippets';
import { ENVIRONMENTS, CUSTOM_EVENT_ANALYTICS } from './constants';
import { removeEmptyKeys } from '../utils/removeEmptyKeys';
import { isAnyConditionTrue } from '../utils/isAnyConditionTrue';

const getDataLayerTag = (): HTMLScriptElement => {
  const dataLayerTag = document.createElement('script');

  dataLayerTag.innerHTML = dataLayerSnippet();

  return dataLayerTag;
};

export type ScriptsObject = {
  scriptGTMTag: HTMLScriptElement;
  noScriptGTMTag: HTMLElement;
};

const getGTMTags = (gtmId: string, environment: string): ScriptsObject => {
  const scriptGTMTag = document.createElement('script');
  scriptGTMTag.innerHTML = GTMSnippetByEnvironment(gtmId, environment);
  const noScriptGTMTag = document.createElement('noscript');
  noScriptGTMTag.innerHTML = GTMIframeSnippetByEnvironment(gtmId, environment);
  return { scriptGTMTag, noScriptGTMTag };
};

export function initGTM({ gtmId = '', environment = '' }): void {
  if (!ENVIRONMENTS.includes(environment.toLowerCase())) return;

  document.head.insertBefore(getDataLayerTag(), document.head.childNodes[0]);

  if (isAnyConditionTrue(!gtmId, environment.toLowerCase() === 'local')) {
    return;
  }

  const { scriptGTMTag, noScriptGTMTag } = getGTMTags(gtmId, environment);

  document.head.insertBefore(scriptGTMTag, document.head.childNodes[1]);
  document.body.insertBefore(noScriptGTMTag, document.body.childNodes[0]);
}

export function sendToGTM(eventInfo: {
  [eventProperty: string]: string | number | string[] | number[];
}): void {
  const eventProps = removeEmptyKeys(eventInfo);

  const requiredKeys = ['event'];

  const isEventFlawled = isAnyConditionTrue(
    !window?.dataLayer,
    !requiredKeys.every((key) => Object.keys(eventProps).includes(key))
  );

  if (isEventFlawled) {
    return;
  }

  window?.dataLayer.push(eventProps);
}

export { ENVIRONMENTS, CUSTOM_EVENT_ANALYTICS };
